import Vue from 'vue'
import VueRouter from 'vue-router'
import store from 'src/store'
import { $error } from 'src/utils/prompt'
import { isWhiteList } from './permission'

Vue.use(VueRouter)

// push
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
// replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/',
    component: () => import('@/layout'),
    // redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/index.vue'),
        meta: {
          title: '系统管理',
        },
      },
      {
        path: '/template',
        name: 'template',
        component: () => import('../views/template/index.vue'),
        meta: {
          title: '系统管理',
        },
      },
      {
        path: '/screen',
        name: 'screen',
        component: () => import('../views/screen/index.vue'),
        meta: {
          title: '系统管理',
        },
      },
    ],
  },
  {
    path: '/system',
    redirect: '/system/basicSetting',
    component: () => import('@/layout'),
    children: [
      {
        path: '/system/basicSetting',
        name: 'basicSetting',
        component: () => import('../views/system/basicSetting/index.vue'),
        meta: {
          title: '系统管理-基础设置',
        },
      },
      {
        path: '/system/personnelManage',
        name: 'personnelManage',
        component: () => import('../views/system/personnelManage/index.vue'),
        meta: {
          title: '系统管理-人员管理',
        },
      },
      {
        path: '/system/dataUpdatedLog',
        name: 'dataUpdatedLog',
        component: () => import('../views/system/dataUpdatedLog/index.vue'),
        meta: {
          title: '系统管理-数据更新日志',
        },
      },
      {
        path: '/system/systemPreserveLog',
        name: 'systemPreserveLog',
        component: () => import('../views/system/systemPreserveLog/index.vue'),
        meta: {
          title: '系统管理-系统维护日志',
        },
      },
      {
        path: '/system/operationLog',
        name: 'operationLog',
        component: () => import('../views/system/operationLog/index.vue'),
        meta: {
          title: '系统管理-操作日志',
        },
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/layout/empty'),
    children: [
      {
        path: '/screen/edit',
        name: 'screenEdit',
        component: () => import('@/views/screen/edit.vue'),
      },
      {
        path: '/screen/edit/:id',
        name: 'screenEdit',
        component: () => import('@/views/screen/edit.vue'),
      },
      {
        path: '/screen/view/:id',
        name: 'screenView',
        component: () => import('@/views/screen/view.vue'),
      },
      {
        path: '/screen/view/:id',
        name: 'screenView',
        component: () => import('@/views/screen/view.vue'),
      },
      {
        path: '/screen/preview',
        name: 'screenPreview',
        component: () => import('@/views/screen/view.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
  },
  {
    path: '*',
    name: 'All',
    component: () => import('@/views/404/index.vue'),
  },

]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach(async (to, from, next) => {
  // 是否白名单
  if (isWhiteList(to)) {
    next()
  } else {
    // 未登录,先登录
    try {
      await store.dispatch('system/getSystemInfo')
      document.title = store.state.system.systemInfo.systemName
      if (!store.state.user.userInfo) {
        await store.dispatch('user/getUserInfo')
      }
      next()
    } catch (err) {
      next({ path: '/login' })
    }
  }
})

router.onError(err => {
  $error('页面加载出错', true)
  throw err
})

export default router
